import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=e929297a&"
import script from "./NotificationList.vue?vue&type=script&lang=ts&"
export * from "./NotificationList.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports